var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailedPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D8C041"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9362 21.4469H19.7447V19.7447H12.9362V21.4469ZM12.9362 18.0426H19.7447V16.3405H12.9362V18.0426ZM11.2341 24.8511C10.766 24.8511 10.3653 24.6844 10.032 24.3511C9.69865 24.0178 9.53198 23.6171 9.53198 23.149V9.53196C9.53198 9.06388 9.69865 8.66317 10.032 8.32983C10.3653 7.9965 10.766 7.82983 11.2341 7.82983H18.0426L23.149 12.9362V23.149C23.149 23.6171 22.9823 24.0178 22.649 24.3511C22.3157 24.6844 21.915 24.8511 21.4469 24.8511H11.2341ZM17.1916 13.7873V9.53196H11.2341V23.149H21.4469V13.7873H17.1916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedPdfIcon);
export default __webpack_public_path__ + "static/media/detailed_pdf_icon.cefdf42ae286829759949f09683bf6e7.svg";
export { ForwardRef as ReactComponent };